import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=74c18d8e&"
import script from "./StatsCard.vue?vue&type=script&lang=ts&"
export * from "./StatsCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports